import apiWrapper from "Helpers/apiWrapper";
import { encodeParams } from "mailup-react-helpers";

const endpoints = ((baseURL) => {
  return {
    //  Generic
    listMessages: (idList, params) =>
      `${baseURL}/list/${encodeURIComponent(idList)}?${encodeParams(params)}`,
    messageByIdMessage: (idMessage) =>
      `${baseURL}/message/${encodeURIComponent(idMessage)}/Lazy`,
    getListActiveMessage: (idList, messageType) =>
      `${baseURL}/list/${idList}/messagetype/${messageType}/active`,
    getMessageMinimumDetails: (idMessage) =>
      `${baseURL}/message/${encodeURIComponent(idMessage)}/Lazy`,
    getAllMessages: (idList, filterBy, orderBy, pageNum, pageSize) =>
      `${baseURL}/list/${encodeURIComponent(idList)}?${encodeParams({
        filterBy,
        orderBy,
        pageNum,
        pageSize,
      })}`,
  };
})(process.env.BEMESS_URL);

export const beMessApiGetAllMessages = (
  idList,
  filterBy = "",
  orderBy = "",
  pageNum = 0,
  pageSize = 0,
) => {
  const url = endpoints.getAllMessages(
    idList,
    filterBy,
    orderBy,
    pageNum,
    pageSize,
  );

  return apiWrapper({
    method: "get",
    url,
  }).then((res) => res.data);
};

/**
 *
 * @param {number} idList
 * @param {Object} params
 * @param {string} params.filterBy
 * @param {string} params.orderBy
 * @param {number} params.pageNum
 * @param {number} params.pageSize
 */
export const beMessListMessages = (idList, params) => {
  const url = endpoints.listMessages(idList, params);
  return apiWrapper({
    method: "get",
    url,
  }).then(({ data }) => data);
};

/**
 *
 * @param {number} idMessage
 */
export const getMessageMinimumDetails = (idMessage) => {
  const url = endpoints.getMessageMinimumDetails(idMessage);
  return apiWrapper({
    method: "get",
    url,
  }).then(({ data }) => data);
};
export const beMessGetMessageByIdMessage = (idMessage) => {
  return apiWrapper({
    method: "get",
    url: endpoints.messageByIdMessage(idMessage),
  }).then(({ data }) => data);
};

/**
 *
 * @param {number} idList
 * @param {'Welcome'|'Confirmation'} messageType
 * @returns {Promise<number>}
 */
export const beMessApiGetListActiveMessage = (idList, messageType) => {
  return apiWrapper({
    method: "get",
    url: endpoints.getListActiveMessage(idList, messageType),
  }).then(({ data }) => data);
};
